module.exports = __webpack_public_path__ + "img/shop-photo5.2d2e2809.jpg";